import React, {useState} from 'react'
import { IoIosClose } from 'react-icons/io'
import '../Addemployee/addemployee.css'
import { IoChevronDown } from 'react-icons/io5'

const Multiselectdrpdwn = ({RoleJson, fieldlabel, roleselected}) => {
  // console.log(RoleJson)
    const [roles, setRoles] = useState()
    const [selectedRoles, setSelectedRoles] = useState([])

    const handleDealsFocus = () =>{
        setRoles(!roles)
    }

    const handleClosedealItem = (e, incoming) =>{
        setSelectedRoles([
          ...selectedRoles.filter(
                (filteredeals)=>(
                  filteredeals !== incoming.itemid
                )
            )
        ])
    }
    
    const handleDealsClick = (e, incoming) =>{
        // check If the item to be added already exists. if it already exist returns True (Then Remove the Item), else False(Add the Item)
        if(selectedRoles.some((exitstingItem) => 
          exitstingItem === incoming.role
        ) === false){
          const updateMonths = [
            ...selectedRoles,
            incoming.role
          ];
    
          setSelectedRoles([...updateMonths])
          roleselected([...updateMonths])
        } else{
            setSelectedRoles([
                ...selectedRoles.filter(
                  (filteredeals)=>(
                    filteredeals !== incoming.role
                  )
                )
            ])
        }
        setRoles(false)
    }

    const handleMouseleave = () =>{
        setRoles(false)
    }

  return (
    <div className='role-select-container'>

        <div className='top-role-container'>
            <span>{fieldlabel}:</span>
        </div>
            <div className="role-sub-select">
                <IoChevronDown id="mult-chevron-down" onClick={handleDealsFocus}/>
                {selectedRoles.map((item, index) => {
                    return(
                        <span id='deals-result' key={index}>
                        {item} 
                        <IoIosClose id='close-deals' onClick={e => handleClosedealItem(e, {itemid: item})}/>
                        </span>
                    )}
                )}
            </div>

            {roles && <div onMouseLeave={handleMouseleave} className='bnw-deals-drpdwn'>{RoleJson.map((item, index) => (
                <span onClick={e => handleDealsClick(e, {key: item.ID, role: item.job_role})} key={index}>{item.job_role}</span>
            ))}
            </div>}
  </div>
  )
}

export default Multiselectdrpdwn